import { gql } from "@apollo/client";

export const DELETE_OPPORTUNITY = gql`
  mutation deleteOpportunity($id: String!) {
    deleteOpportunity(id: $id)
  }
`;
